import { render, staticRenderFns } from "./BusinessSignUpView.vue?vue&type=template&id=3b3f6a5d"
import script from "./BusinessSignUpView.vue?vue&type=script&lang=js"
export * from "./BusinessSignUpView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports